import HexModal from "..";
import { getLabel } from "../../../hooks/use-labels";
import { useWindowWidth } from "../../../hooks/use-breakpoint";
import HexButton from "../../../ui-kit/HexButtons";
import FlexButtons from "../../FlexButtons";
import HexLoader from "../../HexLoader";

const MessageModal = ({
  open,
  onCancel,
  text,
  onOkay,
  buttonLabel,
  title,
  cancelText,
  className,
  modalClass,
  imageSrc,
  loading,
}) => {
  const resizeWidth = useWindowWidth();

  return (
    <HexModal
      open={open}
      onClose={onCancel}
      title={title}
      modalClass={modalClass}
      className={`${className || ""} message-modal`}
    >
      <div
        className={`${
          resizeWidth > 575 ? "mt-24 mb-24" : "mt-12 mb-12"
        }  text-base modal-centered-text`}
      >
        {imageSrc && <img src={imageSrc} alt="messageImage" />}

        {text}
      </div>

      {loading && <HexLoader />}

      <FlexButtons>
        {cancelText && (
          <HexButton
            size="sm"
            type={"outline"}
            className="full-width"
            label={cancelText || getLabel("cancelLabel")}
            onClick={onCancel}
          />
        )}

        <HexButton
          type="primary"
          size="lg"
          disable={loading}
          onClick={onOkay}
          label={buttonLabel || "Okay"}
          className="text-sm full-width"
        />
      </FlexButtons>
    </HexModal>
  );
};

export default MessageModal;
